import * as React from 'react';

import { Typography } from '@coursera/cds-core';

import Modal from 'bundles/phoenix/components/Modal';

type Props = {
  /** Message of the modal. */
  message?: string;
};

/**
 * Blocking status indicator modal.
 *
 * Displayed when the app is busy and the user should not be allowed to interact with the
 * page.
 */
export const ActivityModal = ({ message = '' }: Props) => {
  return (
    // At time of writing modal does not allow pass through of additional properties. To allow selection of modal components
    // we wrap entire contents in `data-e2e` tag.
    <div data-e2e={ActivityModal.e2eName}>
      <Modal
        className="rc-ActivityModal"
        // This gets dropped into an `aria-label` on the modal. This should be translated and in plain language.
        modalName={message}
        allowClose={false}
      >
        <Typography className="message" variant="h1" component="h2">
          {message}
        </Typography>
      </Modal>
    </div>
  );
};

ActivityModal.e2eName = 'staff-management-status-modal';

export default ActivityModal;
